import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SaasContainerAction } from './saas-instance-discovery.service';

export interface SaasContainerActionDialogData {
  action: SaasContainerAction;
  containerName: string;
}

@Component({
  selector: 'app-saas-container-action-dialog',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule],
  template: `
    <h2 mat-dialog-title>{{ data.action === 'start' ? 'Container starten' : 'Container stoppen' }}</h2>
    <mat-dialog-content>
      <p>
        Geben Sie den PB40-Token ein, um
        <strong>{{ data.containerName }}</strong>
        {{ data.action === 'start' ? 'zu starten' : 'zu stoppen' }}.
      </p>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>PB40-Token</mat-label>
        <mat-icon matPrefix>key</mat-icon>
        <input matInput type="password" [(ngModel)]="token" autocomplete="off" spellcheck="false"
          cdkFocusInitial (keydown.enter)="submit()">
      </mat-form-field>
      <small>Der Token wird nur für diese Anfrage verwendet und nicht gespeichert.</small>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">Abbrechen</button>
      <button mat-flat-button [color]="data.action === 'stop' ? 'warn' : 'primary'" type="button"
        [disabled]="!token.trim()" (click)="submit()">
        {{ data.action === 'start' ? 'Starten' : 'Stoppen' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { display: grid; gap: 1rem; min-width: min(24rem, 70vw); }
    p { margin: 0; line-height: 1.55; }
    mat-form-field { width: 100%; }
    small { margin-top: -.5rem; color: var(--app-surface-light, #64748b); line-height: 1.45; }
  `]
})
export class SaasContainerActionDialogComponent {
  token = '';

  constructor(
    readonly dialogRef: MatDialogRef<SaasContainerActionDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) readonly data: SaasContainerActionDialogData
  ) { }

  submit(): void {
    const token = this.token.trim();
    if (token) this.dialogRef.close(token);
  }
}
